import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const updatePlaybookForUser = (userId, payload, callback) => {
  return async (dispatch) => {
    dispatch({ type: 'UPDATING_PLAYBOOK' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        // const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.post(
            `/ads/users/${userId}/playbook`,
            payload,
            {
              params: {
                'request-id': reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
                // 'x-api-version': 'v2',
              },
            },
          );
          if (response.status === 200) {
            await dispatch({
              type: 'UPDATING_PLAYBOOK_DONE',
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'UPDATING_PLAYBOOK_FAILED',
              payload: `Failed to update playbook`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'UPDATING_PLAYBOOK_FAILED',
            payload: `Failed to update playbook`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'UPDATING_PLAYBOOK_FAILED',
        payload: `Failed to update playbook`,
      });
    }
  };
};

export default updatePlaybookForUser;
